module.exports = __webpack_public_path__ + "static/img/Electronic Wire.57b5a60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/Electronic Wire.jpg
// module id = s8vp
// module chunks = 1